import { jsx as _jsx } from "react/jsx-runtime";
import { MobileLinksList } from './MobileLinksList';
const ABOUT_US_LINKS = [
    {
        url: '/about-us',
        name: 'About us',
    },
    {
        url: '/join-displate-club',
        name: 'Displate Club',
    },
    {
        url: '/career',
        name: 'Career',
    },
    {
        url: 'https://blog.displate.com',
        name: 'Blog',
    },
];
export const AboutUsSubNavigation = () => _jsx(MobileLinksList, { links: ABOUT_US_LINKS }, void 0);
//# sourceMappingURL=AboutUsSubNavigation.js.map